const authored = [
  [
    'Sunrise City',
    'sunrise-city',
    18,
    [
      [0, 4],
      [0, 8],
      [1.2, 12],
      [0, 16.8],
    ],
    [
      [-2.8, 6, 1.2],
      [2.9, 11, 2.5],
    ],
    [0, 0],
    0.8,
  ],
  [
    'Frost City',
    'frost-city',
    20,
    [
      [-1, 4],
      [-2, 8],
      [0, 12],
      [1.5, 16],
      [0, 18.8],
    ],
    [
      [2.5, 7, 3],
      [-3, 13, 2],
    ],
    [0.025, 0],
    0.25,
  ],
  [
    'Emerald Forest',
    'emerald-forest',
    21,
    [
      [1.5, 4],
      [-1, 8],
      [-2, 12],
      [1, 16],
      [0, 19.8],
    ],
    [
      [-2.7, 5, 4],
      [2.8, 11, 4],
      [-2.8, 17, 3],
    ],
    [-0.035, 0],
    0.9,
  ],
  [
    'Candy Kingdom',
    'candy-kingdom',
    23,
    [
      [-1.7, 4],
      [1.7, 8],
      [-1.7, 12],
      [1.7, 16],
      [0, 20],
      [0, 21.8],
    ],
    [
      [0, 6, 1],
      [0, 10, 1],
      [0, 14, 1],
    ],
    [0, 0.02],
    0.65,
  ],
  [
    'Golden Desert',
    'golden-desert',
    24,
    [
      [2, 4],
      [2, 8],
      [-1, 12],
      [-2, 16],
      [0, 20],
      [0, 22.8],
    ],
    [
      [-2.8, 6, 2],
      [2.9, 14, 3],
      [2.7, 20, 1.8],
    ],
    [0.07, -0.015],
    0.95,
  ],
  [
    'Coral Beach',
    'coral-beach',
    25,
    [
      [-2, 4],
      [0, 8],
      [2, 12],
      [0, 16],
      [-1, 20],
      [0, 23.8],
    ],
    [
      [2.8, 5, 1.4],
      [-2.8, 11, 2.5],
      [2.8, 19, 2],
    ],
    [-0.05, 0.02],
    0.55,
  ],
  [
    'Volcano Valley',
    'volcano-valley',
    26,
    [
      [1.8, 4],
      [0, 8],
      [-1.8, 12],
      [0, 16],
      [1.8, 20],
      [0, 24.8],
    ],
    [
      [-2.8, 6, 4],
      [2.8, 10, 4],
      [0, 18, 1],
      [-2.8, 23, 4],
    ],
    [0.02, -0.03],
    0.8,
  ],
  [
    'Cloud Islands',
    'cloud-islands',
    27,
    [
      [-1.6, 4],
      [1.6, 8],
      [0, 12],
      [-1.6, 16],
      [1.6, 20],
      [0, 24],
      [0, 25.8],
    ],
    [
      [2.9, 5, 2],
      [-2.9, 11, 3],
      [2.9, 17, 2],
    ],
    [0.055, 0.01],
    0.5,
  ],
  [
    'Underwater Reef',
    'underwater-reef',
    28,
    [
      [0, 4],
      [2, 8],
      [0, 12],
      [-2, 16],
      [0, 20],
      [2, 24],
      [0, 26.8],
    ],
    [
      [-2.9, 7, 3],
      [2.9, 15, 3],
      [-2.9, 23, 3],
    ],
    [-0.045, -0.04],
    0.7,
  ],
  [
    'Starlight Space',
    'starlight-space',
    29,
    [
      [-1.8, 4],
      [0, 8],
      [1.8, 12],
      [0, 16],
      [-1.8, 20],
      [0, 24],
      [0, 27.8],
    ],
    [
      [2.8, 6, 4],
      [-2.8, 14, 4],
      [2.8, 22, 4],
    ],
    [0.035, 0.025],
    0.35,
  ],
  [
    'Neon City',
    'neon-city',
    30,
    [
      [2, 4],
      [-1, 8],
      [2, 12],
      [-1, 16],
      [2, 20],
      [-1, 24],
      [0, 28.8],
    ],
    [
      [-2.8, 5, 5],
      [2.9, 10, 1],
      [0, 18, 1],
      [-2.9, 26, 5],
    ],
    [-0.065, 0],
    0.75,
  ],
  [
    'Cherry Garden',
    'cherry-garden',
    30,
    [
      [-2, 4],
      [-2, 8],
      [1, 12],
      [2, 16],
      [-1, 20],
      [-2, 24],
      [0, 28.8],
    ],
    [
      [2.8, 6, 4],
      [-2.9, 14, 4],
      [2.9, 22, 4],
    ],
    [0.065, 0.015],
    0.9,
  ],
  [
    'Crystal Caverns',
    'crystal-caverns',
    31,
    [
      [0, 4],
      [2, 8],
      [-1, 12],
      [-2, 16],
      [1, 20],
      [2, 24],
      [0, 28],
      [0, 29.8],
    ],
    [
      [-2.9, 6, 5],
      [2.9, 14, 5],
      [-2.9, 22, 5],
    ],
    [0.02, -0.055],
    0.45,
  ],
  [
    'Autumn Woodland',
    'autumn-woodland',
    32,
    [
      [1.8, 4],
      [0, 8],
      [-1.8, 12],
      [0, 16],
      [1.8, 20],
      [0, 24],
      [-1, 28],
      [0, 30.8],
    ],
    [
      [-2.8, 6, 4],
      [2.8, 14, 4],
      [-2.8, 22, 4],
      [2.8, 29, 3],
    ],
    [-0.08, 0.025],
    0.85,
  ],
  [
    'Toy Workshop',
    'toy-workshop',
    33,
    [
      [-2, 4],
      [1, 8],
      [2, 12],
      [-1, 16],
      [-2, 20],
      [1, 24],
      [2, 28],
      [0, 31.8],
    ],
    [
      [2.8, 6, 2.5],
      [-2.8, 12, 3],
      [2.8, 20, 4],
      [-2.8, 28, 4],
    ],
    [0.07, -0.035],
    0.75,
  ],
  [
    'Jungle Ruins',
    'jungle-ruins',
    34,
    [
      [0, 4],
      [-2, 8],
      [0, 12],
      [2, 16],
      [0, 20],
      [-2, 24],
      [0, 28],
      [0, 32.8],
    ],
    [
      [2.8, 6, 5],
      [-2.9, 14, 5],
      [2.9, 22, 5],
      [-2.9, 30, 4],
    ],
    [-0.09, 0.015],
    0.95,
  ],
  [
    'Moon Garden',
    'moon-garden',
    35,
    [
      [2, 4],
      [0, 8],
      [-2, 12],
      [0, 16],
      [2, 20],
      [0, 24],
      [-2, 28],
      [0, 32],
      [0, 33.8],
    ],
    [
      [-2.9, 6, 3],
      [2.9, 14, 4],
      [-2.9, 22, 4],
      [2.9, 30, 3],
    ],
    [0.04, -0.04],
    0.35,
  ],
  [
    'Rainbow Waterfalls',
    'rainbow-waterfalls',
    36,
    [
      [-1.8, 4],
      [1.8, 8],
      [-1.8, 12],
      [1.8, 16],
      [-1.8, 20],
      [1.8, 24],
      [-1.8, 28],
      [0, 32],
      [0, 34.8],
    ],
    [
      [0, 6, 1],
      [0, 10, 1],
      [0, 14, 1],
      [0, 18, 1],
      [0, 22, 1],
      [0, 26, 1],
    ],
    [0.085, 0.04],
    0.55,
  ],
  [
    'Aurora Ice',
    'aurora-ice',
    37,
    [
      [0, 4],
      [2, 8],
      [0, 12],
      [-2, 16],
      [0, 20],
      [2, 24],
      [0, 28],
      [-1, 32],
      [0, 35.8],
    ],
    [
      [-2.9, 6, 5],
      [2.9, 14, 5],
      [-2.9, 22, 5],
      [2.9, 30, 5],
    ],
    [-0.1, -0.035],
    0.18,
  ],
  [
    'Celestial Palace',
    'celestial-palace',
    38,
    [
      [-2, 4],
      [1, 8],
      [-1, 12],
      [2, 16],
      [-2, 20],
      [1, 24],
      [-1, 28],
      [2, 32],
      [0, 36.8],
    ],
    [
      [2.9, 6, 5],
      [-2.9, 10, 5],
      [2.9, 14, 5],
      [-2.9, 18, 5],
      [2.9, 22, 5],
      [-2.9, 26, 5],
      [2.9, 30, 5],
    ],
    [0.1, -0.045],
    0.6,
  ],
];
const foodKinds = ['apple', 'croissant', 'berry', 'cookie', 'banana'];
function build(row, index) {
  const [name, theme, authoredLength, points, blocks, wind, friction] = row,
    id = index + 1;
  const sectorLength = authoredLength * 3,
    length = sectorLength * 4;
  const gateX = (sector) => (sector % 2 ? 1 : -1) * (id < 6 ? 1.5 : 2.4);
  const route = [{ x: 0, z: 0 }];
  // Four paced sectors reuse each world's authored bends, with mirrored and
  // compressed return lanes. Short flight legs reward sustained timing and steering.
  for (let sector = 0; sector < 4; sector++) {
    const mirror = [1, -1, 0.85, -0.85][sector];
    const targets = [
      ...points.slice(0, -1).map(([x, z]) => ({ x: x * mirror, z: z * 3 + sector * sectorLength })),
      {
        x: sector === 3 ? 0 : gateX(sector + 1),
        z: (sector + 1) * sectorLength - (sector === 3 ? 1.2 : 0),
      },
    ];
    for (const target of targets) {
      const start = route.at(-1),
        steps = Math.ceil((target.z - start.z) / 8);
      for (let step = 1; step <= steps; step++)
        route.push({
          x: start.x + ((target.x - start.x) * step) / steps,
          z: start.z + ((target.z - start.z) * step) / steps,
        });
    }
  }
  route.push({ x: 0, z: length });
  const powerups = [0, 1, 2, 3].flatMap((sector) => {
    const p = route.find((p) => p.z >= sector * sectorLength + sectorLength * 0.28);
    return [
      { id: `boost-${sector}`, kind: 'boost', x: p.x, y: 2.8, z: p.z - 2, radius: 0.8 },
      {
        id: `shield-${sector}`,
        kind: 'shield',
        x: sector % 2 ? -2.4 : 2.4,
        y: 2.5,
        z: sector * sectorLength + sectorLength * 0.65,
        radius: 0.85,
      },
    ];
  });
  return {
    id,
    name,
    theme,
    length,
    timeLimitMs: Math.ceil((length / 5 + 45) * 2) * 1000,
    parTimeMs: Math.ceil(length / 5 + 15) * 1000,
    checkpoints: [1, 2, 3].map((sector) => ({
      id: `sector-${sector}`,
      z: sector * sectorLength,
      x: gateX(sector),
      width: id === 1 ? 3.2 : id < 6 ? 2.4 : 2,
    })),
    powerups,
    // Optional edge lanes leave the main route and every required gate intact.
    // Their spring-to-crate arc rejoins well before the next sector barrier.
    bonusRoutes: [0, 1, 2, 3].map((sector) => ({
      id: `bonus-${sector}`,
      x: (sector % 2 ? -1 : 1) * 3.8,
      z: sector * sectorLength + sectorLength * 0.36,
      reward: 600 + sector * 200,
      name: ['Spring school', 'Crate climb', 'Air slalom', 'Expert arc'][sector],
    })),
    trampolines: [0, 1, 2, 3].map((sector) => ({
      id: `spring-${sector}`,
      x: (sector % 2 ? -1 : 1) * 3.8,
      y: 0.25,
      z: sector * sectorLength + sectorLength * 0.36,
      width: id < 6 ? 1.9 : 1.5,
      depth: 5,
    })),
    crates: [0, 1, 2, 3].flatMap((sector) => [
      {
        id: `trail-crate-${sector}`,
        routeId: null,
        kind: sector === 1 ? 'spring' : sector === 2 ? 'reinforced' : 'wood',
        x: 0,
        y: 1.2,
        z: sector * sectorLength + 7,
        points: sector === 2 ? 300 : 150,
      },
      ...[0, 1, 2].map((i) => ({
        id: `bonus-crate-${sector}-${i}`,
        routeId: `bonus-${sector}`,
        kind: 'reward',
        x: (sector % 2 ? -1 : 1) * (3.8 - (sector >= 2 ? i * 0.6 : 0)),
        y: [3.4, 5.1, 4.4][i],
        z: sector * sectorLength + sectorLength * 0.36 + [3, 6, 10][i],
        points: [250, 450, 250][i],
      })),
    ]),
    bounds: { minX: -5, maxX: 5, minZ: -2, maxZ: length + 1.4 },
    start: { x: 0, y: 0.85, z: 0 },
    finish: {
      x: 0,
      y: 0,
      z: length,
      radius: id < 6 ? 1.05 : id < 14 ? 0.9 : 0.78,
    },
    platforms: [
      ...route.map((p, i) => ({
        id: `platform-${i}`,
        ...p,
        y: 0,
        width: i === 0 ? 4 : 3.2,
        depth: i === 0 ? 9 : 8.4,
      })),
      ...(id >= 4
        ? [
            {
              id: 'side-spring',
              x: id % 2 ? 3.8 : -3.8,
              y: 0.5,
              z: length * 0.43,
              width: 1.3,
              depth: 2.5,
            },
          ]
        : []),
    ],
    route,
    wind: { x: wind[0], z: wind[1] },
    friction,
    hazards: [0, 1, 2, 3]
      .flatMap((sector) =>
        blocks.map(([x, z, height], i) => ({
          id: `hazard-${sector}-${i}`,
          type: 'box',
          behavior: id >= 7 && i % 5 === 4 ? 'hazard' : 'bumper',
          x: (x === 0 ? (i % 2 ? 3.2 : -3.2) : x) * [1, -1, 0.95, -0.95][sector],
          y: height / 2,
          z: z * 3 + sector * sectorLength,
          width: 0.75 + (sector === 2 ? 0.15 : 0),
          height,
          depth: 2.25,
          ...((id >= 8 && i === 0) || sector === 3
            ? {
                motion: {
                  axis: 'x',
                  amplitude: 0.18,
                  periodMs: 2800 + id * 90 + sector * 170,
                  phase: index * 0.3,
                },
              }
            : {}),
        })),
      )
      .filter((h) => {
        // Keep the optional aerial teaching corridor free of unrelated scenery hits.
        const sector = Math.floor(h.z / sectorLength);
        const padZ = sector * sectorLength + sectorLength * 0.36;
        const edge = (sector % 2 ? -1 : 1) * 3.2;
        return !(h.z >= padZ - 3 && h.z <= padZ + 18 && Math.abs(h.x - edge) < 1.8);
      }),
    food: route.slice(1, -1).flatMap((p, i) =>
      [0.3, 0.5, 0.7].map((fraction, j) => ({
        id: `food-${i}-${j}`,
        x: route[i].x + (p.x - route[i].x) * fraction,
        y: 0.85 + 7.8 * (1.36 * fraction) - 5.75 * (1.36 * fraction) ** 2,
        z: route[i].z + (p.z - route[i].z) * fraction,
        radius: 0.7,
        kind: foodKinds[(i + j + index) % 5],
        points: 25,
      })),
    ),
  };
}
function freeze(value) {
  if (value && typeof value === 'object') {
    Object.values(value).forEach(freeze);
    Object.freeze(value);
  }
  return value;
}
/** Twenty original authored courses in metres. Route/island markers describe
 * visible scenery, not an automatic solver. Themes share bounded physical rules
 * while authored bends, obstacle placement, wind, grip and finish targets vary. */
export const BOB_LEVELS = freeze(authored.map(build));
/** Return immutable authored geometry; reject an unknown campaign level. */
export function getBobLevel(level = 1) {
  if (!Number.isInteger(level) || level < 1 || level > BOB_LEVELS.length)
    throw new RangeError('Choose a Bob level from1 to20.');
  return BOB_LEVELS[level - 1];
}
